import type { BoxProps } from '@mantine/core';
import { Box, createStyles } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { DOCUMENTATION_WIDTH } from '../Documentation/constants';
import { useAIAssistantContext } from './hooks';
import { AIAssistantMode } from './types';

const useStyles = createStyles(
	(theme, { isSidebar }: { isSidebar: boolean }) => ({
		wrapper: {
			width: '100%',
			maxWidth: isSidebar
				? '100%'
				: `calc(${DOCUMENTATION_WIDTH}px + (2 * 1.5rem))`,
			margin: '0 auto',
			paddingLeft: theme.spacing.xl,
			paddingRight: theme.spacing.xl,
			position: 'relative',

			[theme.fn.smallerThan('md')]: {
				maxWidth: '100%',
			},
		},
	})
);

export const AiViewportWrapper = observer(
	({ children, ...props }: BoxProps) => {
		const { mode } = useAIAssistantContext();
		const { classes } = useStyles({
			isSidebar: mode === AIAssistantMode.SIDEBAR,
		});

		return (
			<Box className={classes.wrapper} {...props}>
				{children}
			</Box>
		);
	}
);
